import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Icon, IconArrowLeftL } from '@flixbus/honeycomb-icons-react';

import styles from './styles.module.css';

/**
 * @param {{ label?: string, href?: string | null, fallback?: string }} props
 *   `href` — renders a `<Link>` when provided; falls back to a `<button>` with browser history otherwise.
 *   `fallback` — route used when there is no browser history entry to go back to.
 */
const GoBack = ({ label = 'Back', href = null, fallback = '/' }) => {
	const navigate = useNavigate();

	if (href !== null) {
		return (
			<div className={styles.back}>
				<Link to={href}>
					<Icon InlineIcon={IconArrowLeftL} size={3} />
					{label}
				</Link>
			</div>
		);
	}

	const handleGoBack = () => {
		// If history has previous entries, go back
		if (window.history.length > 1) {
			navigate(-1);
		} else {
			navigate(fallback);
		}
	};

	return (
		<div className={styles.back}>
			<button onClick={handleGoBack} className={styles.backButton}>
				<Icon InlineIcon={IconArrowLeftL} size={3} />
				{label}
			</button>
		</div>
	);
};

export default GoBack;
